<div class="path-container">
  <span class="path" [innerHTML]="currentpath"></span>
  <!-- <span class="path">{{ currentpath }}</span> -->
</div>
